import { defineStore } from "pinia";
import { summaryKeys, matchesSummaryFilters } from "../utils/cart_summary.js";

const OFFER_CHUNK = 100;

export const useOfferStore = defineStore("OfferStore", {
  state: () => ({
    offers: [],
    offer: null,
    loading: false,
    loading_quantity: false,
    offer_purchases: null,
    operation_response: null,
    filters: {
      already_purchased: 'none',
      in_another_cart: 'none',
      web_reader_compatible: 'none',
      publisher: null
    },
    summary_filters: []
  }),
  getters: {
    offersFiltered() {
      const matchesFilter = (filter, value) => {
        if (filter === 'none') { return true; }
        return (filter === 'yes') === value;
      };

      return this.offers.filter(item => {
        return matchesFilter(this.filters.already_purchased, !!item.publication?.already_purchased) &&
          matchesFilter(this.filters.in_another_cart, !!item.publication?.in_another_cart) &&
          matchesFilter(this.filters.web_reader_compatible, !!item.offer?.online_reading_listening_compatible) &&
          (!this.filters.publisher || item.publication?.publisher?.id === this.filters.publisher.id) &&
          (this.summary_filters.length === 0 || matchesSummaryFilters(summaryKeys(item), this.summary_filters));
      });
    },
    offersSelected() {
      return this.offers.filter(offer => offer.checked);
    },
    offersSelectedReplaced() {
      return this.offers.filter(offer => !offer.original_offer);
    },
    notSelectedOffers() {
      return this.offers.filter(offer => !offer.checked);
    },
    cartOffersQuantity() {
      let quantity = 0;
      this.offers.forEach(item => {
        if (item.offer.quantity) { quantity += item.offer.quantity; }
      });
      return quantity;
    },
    offersUnavailable() {
      return this.offers.filter(item => item.offer.available == false);
    },
    onlyOfferDeleted() {
      return this.offers.filter(item => item.only_offer_deleted);
    },
    offersNotFromDeMarque() {
      return this.offers.filter(item => !item.offer.from_de_marque);
    }
  },
  actions: {
    setFilter(group, value) {
      if (this.filters[group] === value) { return; }
      this.filters[group] = value;
      this.offers.forEach(offer => { offer.checked = false; });
    },
    // FBKS-3962: selected summary values add up, a line shows when it matches any of them
    toggleSummaryFilter(group, value) {
      const index = this.summary_filters.findIndex(filter => filter.group === group && filter.value === value);
      if (index === -1) {
        this.summary_filters.push({ group, value });
      } else {
        this.summary_filters.splice(index, 1);
      }
      this.offers.forEach(offer => { offer.checked = false; });
    },
    async fetchOfferAlreadyPurchased(cartId, offerId) {
      try {
        const response = await this.$axios.get(`/carts/${cartId}/offers/${offerId}/already_purchased.json`);
        if (response.status == 200) {
          this.offer_purchases = response.data
        }
      }
      catch (error){
        console.error('Error fetching data:', error);
      }
    },
    markAsOriginalOffer(offer) {
      const index = this.offers.findIndex(item => item.id === offer.id);
      if (index !== -1) {
        this.offers[index].original_offer = true;
      }
    },
    async reloadOffers(cartId) {
      const offerIds = this.offers.map(offer => offer.offer.id);
      await this.fetchOffers(cartId, offerIds);
    },
    async fetchOffers(cartId, offer_ids, update_items = false) {
      const promises = [];
      if (!update_items) { this.loading = true }
      try {
        for (let i = 0; i < offer_ids.length; i += OFFER_CHUNK) {
          const ids = offer_ids.slice(i, i + OFFER_CHUNK).join(',');
          promises.push(this.$axios.get(`/carts/${cartId}/offers/${ids}.json`));
        }
        const responses = await Promise.all(promises);
        const items = responses.map(response => response.data).flat().filter(item => item.publication);

        if (update_items) {
          items.forEach(cart_item => {
            const offerIndex = this.offers.findIndex(item => item.id === cart_item.id);
            if(typeof offerIndex == 'number') {
              this.offers.splice(offerIndex, 1, cart_item)
            }
          });
        }
        else {
          this.offers = items.sort((a, b) => a.id - b.id);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
      this.loading = false;
    },
    async updateOperationOffers(cartId, offerId, kind = 'disable', newPrice = null) {
      console.log(offerId)
      console.log(kind)
      console.log(newPrice)
      try {
        const params = { operation: kind, new_price: newPrice }
        const response = await this.$axios.post(`/carts/${cartId}/offers/${offerId}/cleanup`, params);
        if (response.status === 200) {
          this.operation_response = response.data;
          const cartItem = this.offers.find(item => item.offer.id === offerId);
          switch (kind) {
            case 'disable':
              return cartItem.offer.available = false;
            case 'update_price':
              return cartItem.price.price_without_taxes = newPrice;
            case 'remove':
              return this.offers = this.offers.filter(item => item.offer.id !== offerId);
            case 'retry':
              return cartItem.status = 'added';
            default:
          }
        }
      }
      catch (error) {
        console.error('Error fetching data:', error);
      }
    },
    incrementQuantity(OfferId) {
      const item = this.offers.find(offer => offer.id === OfferId);
      if (item) {
        item.offer.quantity++;
        this.updateOfferQuantity(item);
      }
    },
    decrementQuantity(OfferId) {
      const item = this.offers.find(offer => offer.id === OfferId);
      if (item) {
        if (item.offer.quantity > 0) {
          item.offer.quantity--;
          this.updateOfferQuantity(item);
        }
      }
    },
    updateQuantity(OfferId, quantity) {
      const item = this.offers.find(offer => offer.id === OfferId);
      if (item) {
        item.offer.quantity = quantity;
        if (quantity !== '' && !isNaN(quantity)) {
          this.updateOfferQuantity(item);
        }
      }
    },
    async updateOfferQuantity(item) {
      this.loading_quantity = true;
      try {
        const data = {
          from_cart: true, items: [{ id: item.offer.id, quantity: item.offer.quantity }]
        }
        await this.$axios.put(`/carts/${item.cart_id}.json`, data);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
      this.loading_quantity = false;
    },
    toggleSelectAll(checked, refundMode = false) {
      const offers = refundMode ? this.offersFiltered.filter(item => item.offer.from_de_marque && item.status === 'validate') : this.offersFiltered;
      offers.forEach(offer => {
        offer.checked = checked;
      });
    },
    removeFromList(itemId) {
      this.offers = this.offers.filter(item => item.id !== itemId);
    },
    async deleteCheckedOffersByCartId(params) {
      const { id, offerIds } = params;
      try {
        if (offerIds.length > 0) {
          const ids = offerIds.join(',');
          const response = await this.$axios.delete(`/carts/${id}/items/${ids}.json`);
          if (response.status === 204) {
            this.offers = this.offers.filter(offer => !offerIds.includes(offer.offer.id));
          }
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    },
    offersOrder(by = 'title') {
      if (by === 'title') {
        return this.offers.sort((a, b) => a.publication.title.localeCompare(b.publication.title));
      }
      else if (by === 'release_date') {
        return this.offers.sort((a, b) => new Date(b.publication.published_at) - new Date(a.publication.published_at));
      }
      else if (by === 'format') {
        return this.offers.sort((a, b) => a.offer.format.localeCompare(b.offer.format));
      }
      else if(by === 'author') {
        return this.offers.sort((a, b) => {
          if (a.publication.authors.length === 0) { return 1; }
          if (b.publication.authors.length === 0) { return -1; }

          const authorA = a.publication.authors[0];
          const authorB = b.publication.authors[0];
          return authorA.localeCompare(authorB);
        });
      }
      else if (by === 'category') {
        return this.offers.sort((a, b) => {
          const getCategory = (categories) => {
            if (!categories || categories.length === 0) return 2;
            const rootCategory = categories[0];
            if (rootCategory === 'FBFIC000000') return 0; // Fiction
            if (rootCategory === 'FBNFC000000') return 1; // Non-Fiction
            return 2; // Other
          };
          return getCategory(a.publication.categories) - getCategory(b.publication.categories);
        });
      }
      else if (by === 'publisher') {
        return this.offers.sort((a, b) => {
          const publisherA = a.publication.publisher?.name;
          const publisherB = b.publication.publisher?.name;
          if (!publisherA) { return publisherB ? 1 : 0; }
          if (!publisherB) { return -1; }
          return publisherA.localeCompare(publisherB);
        });
      }
      else if (by === 'audience') {
        return this.offers.sort((a, b) => {
          const ageA = a.publication.age || '';
          const ageB = b.publication.age || '';
          return ageA.localeCompare(ageB);
        });
      }
      else if (by === 'status') {
        return this.offers.sort((a, b) => {
          const getStatusOrder = (status) => {
            if (status === 'available') return 0;
            if (status === 'unavailable') return 1;
            return 2;
          };
          return getStatusOrder(a.publication.status) - getStatusOrder(b.publication.status);
        });
      }
      else if (by === 'quantity') {
        return this.offers.sort((a, b) => {
          const qtyA = a.offer.quantity || 0;
          const qtyB = b.offer.quantity || 0;
          return qtyA - qtyB;
        });
      }
      else if (by === 'unit_price') {
        return this.offers.sort((a, b) => {
          const priceA = a.price?.price || 0;
          const priceB = b.price?.price || 0;
          return priceA - priceB;
        });
      }
      else if (by === 'total_price') {
        return this.offers.sort((a, b) => {
          const totalA = (a.price?.price || 0) * (a.offer.quantity || 0);
          const totalB = (b.price?.price || 0) * (b.offer.quantity || 0);
          return totalA - totalB;
        });
      }
      else {
        return this.offers.sort((a, b) => a.id - b.id);
      }
    }
  }
});
